// extracted by mini-css-extract-plugin
export default {"container":"boardPage_container__MSvkr"};